import '../../styles/speaker.css';
import logo from '../../assets/images/Q3logotext.png';
import alexander from "../../assets/images/speakers/alexander.jpg";

function Alexander() {
  return (
    <>
    <div class="header">
      <div class="header-content">
        <div class="left">
          <div class="header-box">
            <h1 className="title">Q<sup>3</sup> Initiative: QREATE @ UMD</h1>
          </div>
          <p>September 12, 2025 - September 13, 2025</p>
          <p>University of Maryland, College Park</p>
          <p>Stamp Student Union: Hoff Theatre</p>
        </div>
        <div className="right">
          <img src={logo} className="logo" alt="Q^3 Logo" />
        </div>
      </div>
    </div>
    <div className="speaker-box">
      <div className="speaker-photo">
         <img src={alexander} alt="Alexander Golob" className="speakerspic"/>
      </div>
      <div className="speaker-content">
      <h1>Alexander Golob</h1>
      <h2>Public Artist</h2>
    </div>  
    </div>
    <div className="speaker-content">
      <p className="p">
        Alexander Golob is a Jewish and Italian second-generation public artist with a practice rooted in joy, dialogue, curiosity, and technical experimentation. Golob’s work uses materials like wood, metal, and paints with old and new technologies to explore social dynamics, craft, complicated histories, and layered meanings.
      </p>
      <a href="https://www.alexandergolobart.com/" target="_blank" rel="noreferrer" className="btn" style={{margin: "2rem auto", fontWeight: 400, fontSize: '20px', borderRadius: '0px'}} >
      Alexander Golob Art </a> 
    </div>
    </>
  );
}

export default Alexander;